<template>
  <div class="container">
    <h3 class="title">添加学员</h3>
    <div class="main">
      <div class="main2">
        <span style="color: red">*</span>请正确填写学生信息并上传表格，
        <span style="color: #edb903; cursor: pointer" @click="showTemplete">
          点击下载模板
        </span>
      </div>
      <div>
        <div class="box">
          <BDragDropBox
            v-model="dragDropValue"
            :action-function="onActionDragDrop"
            style="width:1000px;"
          />
        </div>
        <!-- 如果没有下面这行，进度条不会被更新。 Vue的BUG？-->
        <div style="display: none">{{ dragDropValue.dummy }}</div>

        <div v-for="item in this.dragDropValue.data" :key="item.uuid">
          {{ item.name }}
          <BProgress v-model="item.progress" style="width: 100px" />
        </div>
      </div>
      <div>
        <textarea v-if="error.length >0" style="width:400px;height:70px;" v-model="error">
        </textarea>
      </div>
      <div class="main3">
        <BBtnPrimary
          style="margin-right: 5px; margin-left: 5px"
          :clicked="doBack"
          hidden-key=""
          btn-txt="返回"
        />
      </div>
    </div>
  </div>
</template>
<script>
import { getImportExcel } from "@/api/student";
import BBtnPrimary from "../../components2/BBtnPrimary";
import Hub from "../../events/Hub";
import BDragDropBox from "../../components2/BDragDropBox";
import BProgress from "../../components2/BProgress";
import Vue from "vue";
export default {
  name: "import",
  components: {
    BBtnPrimary,
    BDragDropBox,
    BProgress,
  },
  data() {
    return {
      navi: [
        { name: "class-management" },
        { name: "student-management" },
        { name: "student-add-import" },
      ],
      data: {},
      classId: "",
      dragDropValue: {
        data: [],
        dummy: 1,
      },
      error:'',
    };
  },
  created() {
    if (sessionStorage.getItem("store")) {
      this.$store.replaceState(
        Object.assign(
          {},
          this.$store.state,
          JSON.parse(sessionStorage.getItem("store"))
        )
      );
      sessionStorage.removeItem("store");
    }
    window.addEventListener("beforeunload", () => {
      sessionStorage.setItem("store", JSON.stringify(this.$store.state));
    });
  },
  //页面载入之前
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (
        vm.$route.params.classId != null &&
        vm.$route.params.classId != "" &&
        vm.$route.params.classId != undefined
      ) {
        vm.classId = vm.$route.params.classId;
      }
    });
  },
  beforeMount() {
    this.$store.commit("SET_NAVI_DATA", this.navi);
  },
  methods: {
    upload() {
      document.getElementById("fileUpload").click();
    },
    // 返回
    doBack() {
      this.$router.push({
        name: "student-management",
        params: {},
      });
    },
    async showTemplete() {
      // console.log(process.env.VUE_APP_BASE_API)
      window.location.href =
        process.env.VUE_APP_BASE_API+"/student/addStudentTemplateDownLoad"
    },
    // 添加编辑页面返回值
    set(value) {
      if (value == 1) {
        // 成功 页面刷新
        this.doBack();
      }
    },
    async onActionDragDrop(file, callback){
      if (file.size > 1048576) {
        Vue.prototype.$valertbar.show("文件不能大于1MB");
        this.dragDropValue.data = []
        this.error = ""
        return
      }
      var fiex = file.name.substring(
      file.name.lastIndexOf(".") + 1,
      file.name.length
    );
    var newFileFiexs = "doc,xls,xlsx,XLS,XLSX";
    if (newFileFiexs.indexOf(fiex) < 0) {
      Vue.prototype.$valertbar.show("只能导入excel文件！");
      this.dragDropValue.data = []
      this.error = ""
      return
    }
      var formData = new FormData();
      formData.append("file", file);
      formData.append("classId", this.classId);
      const data = await getImportExcel(formData, callback)
      if (data.code === -1 && data.msg !== null) {
        if (String(data.msg).length < 20) {
          this.data.bodyText = data.msg;
          Vue.prototype.$valertbar.show(data.msg);
          if (data.msg == "模板内无数据！") {
            this.dragDropValue.data = []
            this.error = ""
          }
        } else {
          this.error = data.msg
        }
      } else if (data.code === -1 && data.msg === null){
          Vue.prototype.$valertbar.show("模板错误");
          this.dragDropValue.data = []
          this.error = ""
      } else if (data.code === 0) {
        Vue.prototype.$vsnackbar.show(data.msg);
      }
        return data;
    },
  },
  destroyed() {
    Hub.$off("modal-confirm", this.set);
  },
  mounted() {
    this.$nextTick(
      function () {
        Hub.$on("modal-confirm", this.set);
      }.bind(this)
    );
  },
};
</script>

<style lang="scss" scoped>
.container {
  display: flex;
  flex-direction: column;
  height: auto;
}
.main {
  display: flex;
  flex-direction: column;
  margin-left: 50px;
  height: 500px;
}
.main2 {
  display: flex;
  flex-direction: row;
  width: 500px;
  margin-top: 50px;
}
.main3 {
  display: flex;
  flex-direction: row;
  width: 200px;
  margin-top: 100px;
}
.search-functions {
  position: relative;
  top: 0;
  display: flex;
  margin-left: 300px;
}
.label {
  margin-left: 40px;
  margin-right: 15px;
}
.title {
  margin-left: 20px;
}
.btn-detail {
  margin: 0 20px 0 20px;
  color: #0171a3;
  cursor: pointer;
}
.video-box {
  display: flex;
  width: 700px;
  height: 300px;
  margin: 50px 0;
}
.item {
  margin-left: 3px;
  margin-right: 3px;
}
.inner-box {
  display: flex;
  flex-direction: row;
  width: 100%;
  flex-wrap: wrap;
  position: relative;
}
.main1 {
  margin-left: 135px;
  margin-top: 10px;
}
.hidden {
  display: none;
}
.box {
  margin-top: 50px;
  display: flex;
  flex-direction: row;
}
</style>
